<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Copy Feedback Questionare</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row>
                <v-col cols="12" sm="5" md="5">
                    <v-card class="box">
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>From</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-row justify="center" dense>
                            <v-col cols="12">
                                <v-icon color="error">*</v-icon>
                                <v-autocomplete rounded color="#0F2027" :items="academic_year_list" label="Academic Year" item-text="ay" item-value="id" outlined dense v-model="from_academicyear"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12">
                                <v-icon color="error">*</v-icon>
                                <v-autocomplete rounded color="#0F2027" :items="feedback_type_list" label="Feedback Type" item-text="feedbacktype" item-value="ft_id" outlined dense v-model="from_feedbacktype"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="2" md="2" align-self="center">
                    <v-btn class="button" :disabled="from_academicyear==null || from_feedbacktype==null || to_academicyear==null || to_feedbacktype==null" @click="copyQuestions()">Copy Questions</v-btn>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <v-card class="box">
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>To</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-row justify="center" dense>
                            <v-col cols="12">
                                <v-icon color="error">*</v-icon>
                                <v-autocomplete rounded color="#0F2027" :items="academic_year_list" label="Academic Year" item-text="ay" item-value="id" outlined dense v-model="to_academicyear"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12">
                                <v-icon color="error">*</v-icon>
                                <v-autocomplete rounded color="#0F2027" :items="feedback_type_list" label="Feedback Type" item-text="feedbacktype" item-value="ft_id" outlined dense v-model="to_feedbacktype"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-card class="box" v-if="copied_question_list.length != 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Question copy</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table dense class="elevation-1 mytable">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Feedback Type</th>
                                <th>Question Type</th>
                                <th>Question No.</th>
                                <th>Question Statement</th>
                                <th>Weightage</th>
                                <th>Options</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="q in copied_question_list" :key="q.id">
                                <td>{{q.srno}}</td>
                                <td>{{q.feedbacktype}}</td>
                                <td>{{q.feedbackquestiontype}}</td>
                                <td>{{q.qno}}</td>
                                <td>
                                    <span v-if="q.question_statement" v-html="q.question_statement">
                                        {{ q.question_statement }}
                                    </span>
                                </td>
                                <td>
                                    {{q.weightage}}
                                </td>
                                <td>
                                    {{q.option_size}}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-card>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            academic_year_list: [],
            feedback_type_list: [],
            copied_question_list: [],
            from_academicyear: null,
            from_feedbacktype: null,
            to_academicyear: null,
            to_feedbacktype: null,
        }),
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.onload();
        },
        methods: {
            onload() {
                this.overlay = true;
                axios
                    .post("/Feedback/getFeedbackQuestionare")
                    .then((res) => {
                        this.academic_year_list = res.data.academic_year_list;
                        this.feedback_type_list = res.data.feedback_type_list;
                        this.feedback_question_type_list = res.data.feedback_question_type_list;
                        // this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            copyQuestions(){
            if (this.from_academicyear == null || this.from_academicyear == '' || this.from_feedbacktype == null || this.from_feedbacktype == '') {
                this.showSnackbar("#b71c1c", "Please Select required fields!");
                return;
            }
            else if(this.to_academicyear == null || this.to_academicyear == '' || this.to_feedbacktype == null || this.to_feedbacktype == ''){
                this.showSnackbar("#b71c1c", "Please Select required fields!");
                return;
            }
            else{
                this.overlay = true
                const data = {
                    from_academicyear: this.from_academicyear,
                    from_feedbacktype: this.from_feedbacktype,
                    to_academicyear: this.to_academicyear,
                    to_feedbacktype: this.to_feedbacktype,
                };
                axios
                    .post("/Feedback/copyFeedbackQuestionare", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.copied_question_list = res.data.copied_question_list;
                            if (this.copied_question_list.length == 0) {
                                this.showSnackbar("#b71c1c", "Question not present!");
                                return
                            }
                            this.showSnackbar("#4caf50", res.data.status_reason);
                            // alert("questionNo"+this.questionNo)
                        }else{
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            }
        }
        },
        
    };
</script>
<style scoped>
.mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
</style>
